import { useEffect, useRef, useState } from 'react';

import { ACTIVE_THREAD_STORAGE_KEY, SELECTED_CHART_STORAGE_KEY } from '../../../constants/aiAnalytics';

function readStoredSelection() {
  return {
    threadId: sessionStorage.getItem(ACTIVE_THREAD_STORAGE_KEY),
    chartId: sessionStorage.getItem(SELECTED_CHART_STORAGE_KEY)
  };
}

export default function useSessionSelectionRestore({
  activeThreadId,
  selectedChartId,
  savedCharts,
  onRestoreThread,
  onRestoreChart
}) {
  const [storedSelection] = useState(readStoredSelection);
  const threadRestoreStartedRef = useRef(false);
  const [threadRestoreSettled, setThreadRestoreSettled] = useState(!storedSelection.threadId);
  const [chartRestoreSettled, setChartRestoreSettled] = useState(!storedSelection.chartId);

  useEffect(
    function restoreStoredThread() {
      if (threadRestoreStartedRef.current) {
        return;
      }
      threadRestoreStartedRef.current = true;
      if (!storedSelection.threadId || activeThreadId) {
        setThreadRestoreSettled(true);
        return;
      }
      Promise.resolve(onRestoreThread(storedSelection.threadId)).finally(() => setThreadRestoreSettled(true));
    },
    [storedSelection, activeThreadId, onRestoreThread]
  );

  useEffect(
    function restoreStoredChartAfterThreadLoad() {
      if (chartRestoreSettled || !threadRestoreSettled || savedCharts.length === 0) {
        return;
      }
      const chart = savedCharts.find(c => c.id === storedSelection.chartId);
      if (chart) {
        onRestoreChart(chart);
      }
      setChartRestoreSettled(true);
    },
    [chartRestoreSettled, threadRestoreSettled, storedSelection, savedCharts, onRestoreChart]
  );

  useEffect(
    function persistActiveThreadAfterRestore() {
      if (!threadRestoreSettled) {
        return;
      }
      if (activeThreadId) {
        sessionStorage.setItem(ACTIVE_THREAD_STORAGE_KEY, activeThreadId);
      } else {
        sessionStorage.removeItem(ACTIVE_THREAD_STORAGE_KEY);
      }
    },
    [threadRestoreSettled, activeThreadId]
  );

  useEffect(
    function persistSelectedChartAfterRestore() {
      if (!chartRestoreSettled) {
        return;
      }
      if (selectedChartId) {
        sessionStorage.setItem(SELECTED_CHART_STORAGE_KEY, selectedChartId);
      } else {
        sessionStorage.removeItem(SELECTED_CHART_STORAGE_KEY);
      }
    },
    [chartRestoreSettled, selectedChartId]
  );
}
